import React, { CSSProperties } from 'react';
import { makeStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'grid',
    gridTemplateRows: '1fr auto 2fr',
  },
  emptyViewContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyViewTextContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '20px',
  },
  emptyViewMessage: {
    textAlign: 'center',
  },
}));

interface IProps {
  title?: string;
  message?: string | React.ReactNode;
  heightDeductionAmount?: number;
  element?: React.ReactNode;
  style?: CSSProperties;
}
/**
 * @deprecated
 * mds-v2 로 변경
 */
const MDSEmptyView = (props: IProps) => {
  const classes = useStyles();
  const { title, message, element, heightDeductionAmount = 0, style } = props;

  return (
    <Paper
      elevation={0}
      className={classes.wrapper}
      style={{ height: `calc(100% - ${heightDeductionAmount}px)`, ...style }}
    >
      <div />
      <Grid item container className={classes.emptyViewContentWrapper}>
        <div className={classes.emptyViewTextContent}>
          <MDSTypography variant="title" weight="medium" size="l">
            {title}
          </MDSTypography>
          <MDSTypography
            className={classes.emptyViewMessage}
            variant="body"
            size="m"
            weight="regular"
            color="color/content/neutral/secondary/normal"
          >
            {message}
          </MDSTypography>
        </div>
        {element}
      </Grid>
      <div />
    </Paper>
  );
};

export default MDSEmptyView;
